import { render, staticRenderFns } from "./VoterDialog.vue?vue&type=template&id=2998b0a6&"
import script from "./VoterDialog.vue?vue&type=script&lang=js&"
export * from "./VoterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports